export default __webpack_public_path__ + "static/media/icn-bad.e812966b.svg";